var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _linearGradient, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsbx: "https://boxy-svg.com",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    bxorigin: "-0.535705 0.261952",
    fill: "#5059C9",
    d: "M16.74 9.222h6.2c.585 0 1.06.475 1.06 1.061v5.646c0 2.153-1.745 3.898-3.897 3.898h-.019c-2.152 0-3.898-1.745-3.898-3.897V9.776c0-.306.248-.554.554-.554Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    bxorigin: "-1.277467 1.77508",
    cx: 20.93,
    cy: 5.594,
    r: 2.512,
    fill: "#5059C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    bxorigin: "0.346197 1.536659",
    cx: 13.116,
    cy: 4.478,
    r: 3.628,
    fill: "#7B83EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.431814 0.199083",
    fill: "#7B83EB",
    d: "M17.954 9.222H7.721c-.579.014-1.037.495-1.023 1.073v6.441c-.081 3.473 2.666 6.355 6.139 6.44 3.473-.085 6.221-2.967 6.14-6.44v-6.441c.013-.578-.445-1.059-1.023-1.073Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.791708 0.2765",
    d: "M13.395 9.222v9.025c-.002.414-.253.786-.636.943-.122.052-.253.079-.385.079H7.189c-.073-.185-.14-.369-.196-.559-.195-.64-.295-1.306-.295-1.975v-6.441c-.014-.578.443-1.058 1.021-1.072h5.676Z",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.863666 0.261952",
    d: "M12.837 9.222v9.583c0 .133-.026.264-.078.385-.158.383-.529.634-.943.637H7.451c-.095-.184-.184-.369-.262-.558-.078-.19-.14-.369-.196-.559-.195-.64-.295-1.306-.295-1.975v-6.441c-.014-.578.443-1.058 1.021-1.072h5.118Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.863666 0.292791",
    d: "M12.837 9.222v8.467c-.004.562-.459 1.017-1.021 1.021H6.993c-.195-.64-.295-1.306-.295-1.975v-6.441c-.014-.578.443-1.058 1.021-1.072h5.118Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.950012 0.292791",
    d: "M12.279 9.222v8.467c-.004.562-.459 1.017-1.021 1.021H6.993c-.195-.64-.295-1.306-.295-1.975v-6.441c-.014-.578.443-1.058 1.021-1.072h4.56Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.633474 2.395199",
    d: "M13.395 6.337v1.758c-.095.005-.184.011-.279.011-.095 0-.184-.006-.279-.011-.188-.013-.375-.043-.558-.09-1.13-.267-2.064-1.06-2.512-2.132-.077-.18-.136-.367-.178-.558h2.785c.563.002 1.019.458 1.021 1.022Z",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.727362 2.757426",
    d: "M12.837 6.895v1.2c-.188-.013-.375-.043-.558-.09-1.13-.267-2.064-1.06-2.512-2.132h2.049c.563.002 1.019.458 1.021 1.022Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.727362 2.757426",
    d: "M12.837 6.895v1.2c-.188-.013-.375-.043-.558-.09-1.13-.267-2.064-1.06-2.512-2.132h2.049c.563.002 1.019.458 1.021 1.022Z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.888934 2.873827",
    d: "M12.279 6.895v1.11c-1.13-.267-2.064-1.06-2.512-2.132h1.491c.563.002 1.019.458 1.021 1.022Z",
    opacity: 0.2
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 198.099,
    x2: 942.2344,
    y1: 1683.0726,
    y2: 394.2607,
    gradientTransform: "matrix(.010768 0 0 -.010768 0 23.197118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.977278 0.498982",
    fill: "url(#a)",
    d: "M1.023 5.873h10.233c.565 0 1.023.458 1.023 1.023v10.233c0 .565-.458 1.023-1.023 1.023H1.023C.458 18.152 0 17.694 0 17.129V6.896c0-.565.458-1.023 1.023-1.023Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "1.588301 0.498121",
    fill: "#FFF",
    d: "M8.832 9.768H6.786v5.57H5.483v-5.57H3.447V8.687h5.385v1.081Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoft_teams.eca18e9e0b8edbfcff3e6b359272629a.svg";
export { ForwardRef as ReactComponent };